export default "__VITE_ASSET__DA$T3vOw__"